import { render, staticRenderFns } from "./ParentDrawer.vue?vue&type=template&id=3245f111&scoped=true"
import script from "./ParentDrawer.vue?vue&type=script&lang=js"
export * from "./ParentDrawer.vue?vue&type=script&lang=js"
import style0 from "./ParentDrawer.vue?vue&type=style&index=0&id=3245f111&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3245f111",
  null
  
)

export default component.exports